import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowDownToLine, Menu, X } from "lucide-react";
import "./CSS/maintopbar.css";

const siteLinks = [
  { label: "Features", href: "/#features" },
  { label: "How it works", href: "/#how-it-works" },
  { label: "Reports", href: "/#reports" },
];

export default function Maintopbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="mtb-header">
      <div className="mtb-inner">
        <Link to="/" className="mtb-brand" onClick={closeMenu} aria-label="Screenshot Monitor home">
          <span className="mtb-brand-mark"><img src="/eyloho.ico" alt="" /></span>
          <span>Screenshot <strong>Monitor</strong></span>
        </Link>
        <nav className="mtb-nav-desktop" aria-label="Main navigation">
          {siteLinks.map((item) => <a href={item.href} key={item.label}>{item.label}</a>)}
          <a href="/Screenshotmonitor.zip" download><ArrowDownToLine size={15} /> Download app</a>
        </nav>
        <div className="mtb-actions">
          <Link to="/login" className={`mtb-login${pathname === "/login" ? " is-current" : ""}`}>Log in</Link>
          <Link to="/signup" className="mtb-signup">Get started <span aria-hidden="true">↗</span></Link>
          <button type="button" className="mtb-menu-toggle" aria-label={isOpen ? "Close menu" : "Open menu"} aria-expanded={isOpen} aria-controls="public-mobile-nav" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {isOpen && (
        <nav className="mtb-nav-mobile" id="public-mobile-nav" aria-label="Mobile navigation">
          {siteLinks.map((item) => <a href={item.href} key={item.label} onClick={closeMenu}>{item.label}</a>)}
          <Link to="/login" onClick={closeMenu}>Log in</Link>
          <Link to="/signup" onClick={closeMenu}>Get started</Link>
          <a href="/Screenshotmonitor.zip" download onClick={closeMenu}><ArrowDownToLine size={17} /> Download desktop app</a>
        </nav>
      )}
    </header>
  );
}
